<section class="home__hero">
  <img
    ngSrc="/assets/v2/bg/home_bg.webp"
    class="home__hero--bg"
    fill
    priority
    sizes="100vw"
    alt="hero background"
  />
  <div class="home__hero--container">
    <div class="home__hero-toggle">
      <app-toggle
        variant="primary"
        [options]="programTypeOptions()"
        [value]="selectedProgramType()"
        (change)="onProgramTypeChange($event)"
      />
    </div>
    <div class="mb-8">
      <h1 class="hero-display text-center text-purple-800">
        Compare & Find Your Perfect
        <span class="text-purple-500">{{ programTypeLabelMap[selectedProgramType()].title }}</span>
      </h1>
    </div>
    <div>
      <app-autocomplete-search
        [resetToken]="resetTypeaheadToken()"
        [hintTemplate]="hintTemplate"
        [placeholder]="programTypeLabelMap[selectedProgramType()].placeholder"
        [minChars]="3"
        [disableFirstOptionOnSubmit]="true"
        [apiMode]="true"
        [options]="options()"
        [suggestions]="suggestions()"
        suggestionLabel="PROGRAMS"
        hintMessage="Search requires a minimum of 3 characters"
        [searchType]="'specialty'"
        (typeahead)="onTypeahead($event)"
        (cleared)="onCleared()"
        (search)="onSearch($event)"
        (selectedValue)="onSelectedValue($event)"
      />
    </div>

    @if (suggestedPrograms().length > 0) {
      <div class="home__hero--chips-container">
        @if (suggestedProgramTitle()) {
          <p class="home__hero--chips-title">{{ suggestedProgramTitle() }}</p>
        }
        <div class="home__hero--chips-list">
          @for (suggestedProgram of suggestedPrograms(); track suggestedProgram.id) {
            <a
              [title]="suggestedProgram.label"
              [routerLink]="suggestedProgram.url"
              [queryParams]="suggestedProgram.queryParams"
              class="rounded-3xl"
              (click)="onChipClick(suggestedProgram)"
            >
              <app-chip
                [label]="suggestedProgram.label"
                [withIcon]="!!suggestedProgram.icon"
                [iconName]="suggestedProgram.icon || ''"
                [iconType]="suggestedProgram.iconType || ''"
              />
            </a>
          }
        </div>
      </div>
    } @else if (isLoading()) {
      <div class="home__hero--chips-placeholder" aria-hidden="true"></div>
    }
  </div>

  @defer (on idle) {
    <app-browse-specialties
      [selectedTabInput]="selectedProgramType() === 'Residency' ? 'Residencies' : 'Fellowships'"
      (searchClicked)="searchSpecialtyModal($event)"
      (closeModal)="afterModalClose($event)"
      [isModalOpen]="showSpecialtyModal"
    />
  }
</section>

<ng-template #hintTemplate>
  <span class="home__hero-hint">
    <span>Search requires a minimum of 3 characters</span>
    <app-button variant="link" label="View All Specialties" (clicked)="openSpecialtiesModal()" />
  </span>
</ng-template>
